import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Image, Col, Row, FormControl, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import debounce from "lodash/debounce";
import moment from "moment";
import DocumentsService from "../../../services/DocumentsService";
import HandleError from "../../../services/HandleError";
import InlineError from "../../messages/InlineError";
import LoaderInline from "../../helpers/LoaderInline";
import LoadingSVG from "../../helpers/LoadingSVG";

class DocumentsEditForm extends Component {

    state = {
    	isLoadingDocument: true,
    	isUpdatingDocument: false,
    	isLoadingUsers: true,
    	formData:{},
    	errors: {}
    }
	
    componentDidMount() { this.getDocument(); }

    onChange = (e) => { this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.value} }); }

	onSubmit = (e) => {
		e.preventDefault();
		this.setState({ isUpdatingDocument: true, errors: {} });
		const { documentId } = this.props.match.params;		
		this.documentService.update(documentId, this.state.formData).then((res) => {
			this.setState({isUpdatingDocument: false});
			NotificationManager.success("Document updated.","Success!");
			this.props.history.push("/documents");	 
		}).catch((err) => {
			this.setState({isUpdatingDocument: false});
			HandleError(err, this);
		});
	}

	getDocument = () => {
		const {documentId} = this.props.match.params;
		this.documentService.show(documentId).then((res) => {
			this.setState({
				...this.state,
				isLoadingDocument:false,
				formData: {
					link: res.data.document && res.data.document.link, 
					name: res.data.document.name && res.data.document.name
				}
			});
		}).catch((err) => {
			this.setState({ isLoadingDocument: false });
			HandleError(err, this);
		});
	}
      
	documentService = new DocumentsService(this);

	render() {
		 const { isLoadingDocument, isUpdatingDocument, formData, errors, selectedEmployee} = this.state;
	 	return (
    		<React.Fragment>
				{isLoadingDocument ? <LoadingSVG /> :  
					<Row>
						<form onSubmit={this.onSubmit}>
							<Col md={4} sm={12}>
								<span className="column-title">Documents details</span>

								<FormGroup validationState={errors.name && "error"}>
									<ControlLabel>Name</ControlLabel>                                  
									<FormControl type="text" name="name" placeholder="Enter name" value={formData.name || ""} onChange={this.onChange}/>						
									{errors.name && <InlineError text={errors.name} />}								                                							
								</FormGroup>						
								
								<FormGroup validationState={errors.link && "error"}>
									<ControlLabel>Link</ControlLabel>                                  
									<FormControl type="text" name="link" placeholder="Enter link" value={formData.link || ""} onChange={this.onChange}/>						
									{errors.link && <InlineError text={errors.link} />}								                                							
								</FormGroup>

								<Button className="btn-crud" bsStyle="primary" disabled={isUpdatingDocument} type="submit">{isUpdatingDocument?"Updating...":"Update"}</Button> 
								{ isUpdatingDocument ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }																												
							</Col>	
						</form>						
					</Row>		
				}
    		</React.Fragment>
    	);
	 }
}
DocumentsEditForm.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			documentId: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};
export default DocumentsEditForm;


// WEBPACK FOOTER //
// ./src/components/forms/documents/DocumentsEditForm.js